import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/api/memberend/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/api/memberend/admin/info',
    method: 'get',
    params: { }
  })
}

// export function logout() {
//   return request({
//     url: '/api/memberend/user/logout',
//     method: 'post'
//   })
// }
